import { combineReducers } from "redux";
import obterConfiguracao from "./actions/obterConfiguracao";
import obterTema from "./actions/obterTema";

export const configuracao = combineReducers({
  obterConfiguracao,
  obterTema
});
